<div class="widget">
  <div class="amSuite-widget-header">
    {{'widgets.activity-graphs.hour-graph.title' | translate}}
    @if (modify) {
      <a href="javascript:void(0)" (click)="actpop()" class="modify-btn"
        pTooltip="{{'widgets.user-activities.edit' | translate}}">
        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
      </a>
    }
    @if (!modify) {
      <small class="date-font"><i>({{ initialDate | dateMoment:shortDate }} -
        {{ finalDate | dateMoment:shortDate }})</i></small>
    }
  </div>
  <div class="graph-widget amSuite-widget-block height-auto" style="overflow-y: hidden;">
    @switch (status) {
      @case ('ready') {
        <div class="chart-card-content">
          <div class="time-sheet-content">
            <div class="progress-container">
              <div class="progress-ring">
                <svg viewBox="0 0 120 120">
                  <circle class="progress-background" cx="60" cy="60" r="50"></circle>
                  <circle class="progress-fill" cx="60" cy="60" r="50"
                    [style.stroke-dasharray]="(totalActivityTimeSum > 0 ? (workedActivityTimeSum / totalActivityTimeSum * 314) : 0) + ' 314'">
                  </circle>
                </svg>
                <div class="progress-text">
                  <span class="progress-value">
                    {{ (totalActivityTimeSum > 0 ? (workedActivityTimeSum / totalActivityTimeSum * 100) : 0) | number:'1.2-2' }}%
                  </span>
                </div>
              </div>
            </div>
            <div class="time-details">
              <div class="time-item">
                <span class="time-label">{{ 'chart-view.worked-time' | translate }}</span>
                <span class="time-value">{{ workedActivityTimeSum | number:'1.0' }}</span>
              </div>
              <div class="time-item">
                <span class="time-label">{{ 'chart-view.total-time' | translate }}</span>
                <span class="time-value">{{ totalActivityTimeSum | number:'1.0' }}</span>
              </div>
            </div>
          </div>
        </div>
      }
      @case ('busy') {
        <div>
          <p>
            <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
          </p>
        </div>
      }
    }
  </div>
</div>
